<template>
  <section>
    <div v-for="(item, index) in groupedItems" :key="index" :class="matrixClasses">
      <MoleculeMatrixImage v-if="typeIs(item, 'image')" :image="item.image" :image-large="item.imageLarge" :size="item.displayType" :subtitle="item.subtitle" />
      <MoleculeMatrixVideo v-if="typeIs(item, 'video')" :video-code="item.youtube.code" :subtitle="item.subtitle" />
      <MoleculeMatrixFoldout v-if="typeIs(item, 'foldout_entries_group')" :items="item.items" :color-theme="colorTheme" />
      <MoleculeMatrixForm v-if="typeIs(item, 'form')" :handle="item.form.handle" />
      <MoleculeMatrixBanner
        v-if="item.banner && typeIs(item, 'banner')"
        :title="item.banner.title"
        :top-label="item.banner.label"
        :sub-label="item.banner.subtitle"
        :button-title="item.banner.buttonTitle"
        :button-url="item.banner.buttonUrl"
        :theme="item.banner.theme"
        :image="item.banner.image"
        :icon="item.banner.icon ? item.banner.icon.slug : undefined"
        :type="typeIs(item, 'banner') ? 'discovery' : ''"
      />
      <!--<DebugDump v-if="typeIs(item, 'audio')" :value="item" title="TODO: CGBR-3332 Matrix Item Audio" />-->
      <!-- only images for now -->
      <MoleculeMatrixCarousel v-if="typeIs(item, 'carousel')" :items="item.images" :hide-captions="item.hideImageCaption" />
      <MoleculeMatrixDiscoveries
        v-if="typeIs(item, 'discoveries')"
        :items="item.discoveries"
        :title="item.title"
        :button-label="item.buttonLabel"
        :button-url="item.buttonUrl"
        :color-theme="colorTheme"
      />
      <MoleculeMatrixEvents
        v-if="typeIs(item, 'events')"
        :uris="item.eventUris"
        :title="item.title"
        :button-label="item.buttonLabel"
        :button-url="item.buttonUrl"
        :color-theme="colorTheme"
      />
      <MoleculeMatrixSearchEvents
        v-if="typeIs(item, 'searchEvents')"
        :maximum-items="item.maximumItems"
        :keywords="item.keywords"
        :search-from-date="item.searchFromDate"
        :event-types="item.eventTypes"
        :genres="item.genres"
        :organizers="item.organizers"
        :composers="item.composers"
        :instruments="item.instruments"
        :rooms="item.rooms"
        :specials="item.specials"
        :hide-sold-out-concerts="item.hideSoldOutConcerts"
        :title="item.title"
        :button-label="item.buttonLabel"
        :button-url="item.buttonUrl"
        :color-theme="colorTheme"
      />
      <MoleculeMatrixOverviewSectionEntries
        v-if="typeIs(item, 'overview_section_entries_group')"
        :title="get(item, 'header.label')"
        :subtitle="get(item, 'header.subtitle')"
        :entries="item.items"
        :color-theme="colorTheme"
      />
      <MoleculeMatrixText v-if="typeIs(item, 'text')" :color-theme="colorTheme" :description="item.description" :background-color="backgroundColor" :mobile-theme="mobileTheme" />
      <MoleculeMatrixDiscoveryShelf
        v-if="typeIs(item, 'discoveryShelf')"
        :label="item.label"
        :portrait="item.slidesVisible ? item.slidesVisible === 'portrait' : false"
        :slides-visible="item.slidesVisible ? (item.slidesVisible === 'portrait' ? 3 : parseInt(item.slidesVisible)) : undefined"
        :entries="item.entries"
        :button-title="item.buttonTitle"
        :button-url="item.buttonUrl"
      />
      <MoleculeMatrixCollectionShelf
        v-if="typeIs(item, 'collectionShelf')"
        :label="item.label"
        :entries="item.entries"
        :button-title="item.buttonTitle"
        :button-url="item.buttonUrl"
      />
      <MoleculeMatrixVriendenLoterijVipCard
        v-if="typeIs(item, 'vriendenloterijcheck')"
        :label="item.label"
        :description="item.description"
        :success-text="item.success"
        :invalid-text="item.invalid"
      />
      <MoleculeMatrixNewsletter v-if="typeIs(item, 'newsletter')" :label="item.label" :origin="item.origin" :endpoint-path="item.newsletterEndpointPath" :url="item.url" />
      <MoleculeMatrixWidget
        v-if="typeIs(item, 'widget')"
        :label="item.label"
        :widget-height="item.widgetHeight"
        :widget-url="item.widgetUrl"
        :append-page-url-parameters="item.appendPageUrlParameters"
        :color-theme="colorTheme"
      />
      <MoleculeMatrixHubspotForm v-if="typeIs(item, 'hubspotForm')" :form-id="item.formId" />
      <MoleculeMatrixCookieDeclaration v-if="typeIs(item, 'cookieDeclaration')" :cookiebot-id="item.cookiebotId" />
    </div>
  </section>
</template>

<script setup lang="ts">
import get from 'lodash/get'

const props = defineProps({
  items: { type: Array as PropType<any[]>, required: true },
  backgroundColor: { type: String, required: false, default: 'bg-white' },
  colorTheme: { type: String, required: false, default: undefined },
  mobileTheme: { type: String, required: false, default: undefined },
  matrixClasses: { type: String, required: false, default: 'mb-10 md:mb-16' },
})

const { groupedItems } = setupDynamicContentItems(props.items)
const typeIs = itemTypeIs
</script>
